import type { EntityAdminRecord } from '@src/components/EntityAdmin/types';
import { get } from 'lodash-es';
import { ModeEnum } from '../../../../../types';
import { ButtonGroup } from '../../../../Button';
import { FormControlSizes, Toggle } from '../../../../Form';
import type { InlineToggleDrawerOption } from '../types';

export function InlineToggleContent<TDrawerRecord extends EntityAdminRecord>({
  drawerOption,
  form,
  onFormUpdate,
}: {
  drawerOption: InlineToggleDrawerOption<TDrawerRecord>;
  form: TDrawerRecord;
  onFormUpdate: (field: keyof TDrawerRecord, value: string | boolean) => void;
}) {
  return (
    <ButtonGroup justifyContent="flex-end" flex="1">
      <Toggle
        size={FormControlSizes.Default}
        checked={get(form, drawerOption.field) === ModeEnum.Enabled}
        onChange={value => onFormUpdate(drawerOption.field, value ? ModeEnum.Enabled : ModeEnum.Disabled)}
        data-testid={`entity-admin-drawer-${String(drawerOption.field)}`}
      />
    </ButtonGroup>
  );
}
